import { useQuery } from '@tanstack/react-query'
import { getShmpListokFact } from '@/services/shmpService'
import type { ShmpCourseNumber, ShmpListokFactSummary } from '@/types'

export function useShmpListokFact(params: {
  periodId: number | null
  weekNumber: number | null
  courseNumber: ShmpCourseNumber | null
}) {
  const query = useQuery<ShmpListokFactSummary, Error>({
    queryKey: ['shmp-listok-fact', params.periodId, params.weekNumber, params.courseNumber],
    queryFn: () => getShmpListokFact({
      periodId: params.periodId as number,
      weekNumber: params.weekNumber,
      courseNumber: params.courseNumber,
    }),
    enabled: params.periodId !== null,
    staleTime: 60_000,
  })

  return {
    data: query.data ?? { fact_revenue_rub: 0 },
    loading: query.isLoading,
    error: query.error?.message ?? null,
    refresh: query.refetch,
  }
}
